/*
 * Author: Dw
 * File Created: Tuesday, 24-08-06 09:13 pm
 * Last Modified: Monday, 25-03-17 03:17 pm, by Harper Yan
 */

import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Box } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import Image from '@/components/Image';
import { useUserInfo } from '@/stores/useUserStore';
import { staticImgPrefix } from '@/utils/prefix';
import GradientButton from './GradientButton';
import LanguageSwitcher from './LanguageSwitcher';
import type { HeaderMenuItem } from './useHeaderConfig';

// const GradientButton = styled(Button)(({ theme, }) => ({
//   position: 'relative',
//   padding: '10px 20px',
//   borderRadius: '20px',
//   background: 'transparent',
//   border: '2px solid transparent',
//   fontSize: '16px',
//   color: '#fff',
//   zIndex: 1,
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     borderRadius: 'inherit',
//     padding: '2px',
//     background: 'linear-gradient(90deg, #60328c, #DF6969)',
//     WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
//     WebkitMaskComposite: 'xor',
//     maskComposite: 'exclude',
//     zIndex: -1,
//   },
//   '&:hover': {
//     backgroundColor: 'rgba(255, 255, 255, 0.1)',
//   },
// }));

const PcHeader: React.FC<{
  configs: HeaderMenuItem[];
}> = ({
  configs
}) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const {
    isLogin,
    loading
  } = useUserInfo();
  const onApply = () => {
    if (isLogin) {
      router.push('/dvault');
    } else {
      router.push('/signup');
    }
  };
  return <Flex maxWidth="lg" sx={{
    alignItems: 'center',
    height: '60',
    justifyContent: 'space-between',
    px: 2,
    width: '100%'
  }} data-sentry-element="Flex" data-sentry-component="PcHeader" data-sentry-source-file="PcHeader.tsx">
      <Image alt="logo" height={36} onClick={() => {
      router.push('/');
    }} src={staticImgPrefix('/header/logo-img.webp')} style={{
      cursor: 'pointer'
    }} width={52} data-sentry-element="Image" data-sentry-source-file="PcHeader.tsx" />
      <Box alignItems="center" display="flex" justifyContent="flex-end" data-sentry-element="Box" data-sentry-source-file="PcHeader.tsx">
        {configs.map(item => <Link href={item.href} key={item.title} style={{
        textDecoration: 'none',
        color: '#fff',
        fontSize: '14px',
        fontWeight: 500,
        pointerEvents: 'all',
        marginRight: '34px',
        cursor: 'pointer',
        ...(item.highlight && {
          background: `linear-gradient(90deg, #E1C49A 0%, #E0C6A0 4%, #DAD3C8 33%, #D9D9D8 48%, #DECAAD 81%, #E1C49A 100%)`,
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        })
      }} target={item.target}>
            {item.title}
          </Link>)}
        <GradientButton disabled={loading} onClick={onApply} sx={{
        fontSize: '14px',
        fontWeight: 500,
        p: '5px 24px'
      }} variant="text" data-sentry-element="GradientButton" data-sentry-source-file="PcHeader.tsx">
          {t('header.apply')}
        </GradientButton>
        <Box sx={{
        width: '1px',
        height: '20px',
        mx: 3,
        background: 'rgba(79, 88, 103, 0.50)'
      }} data-sentry-element="Box" data-sentry-source-file="PcHeader.tsx" />
        <LanguageSwitcher data-sentry-element="LanguageSwitcher" data-sentry-source-file="PcHeader.tsx" />
      </Box>
    </Flex>;
};
export default PcHeader;